export const VALID_TONES = ['professional', 'friendly', 'bold', 'casual', 'playful'];
export const VALID_BRAND_IMAGE_TAGS = ['products', 'people', 'other'];
export const BRAND_IMAGE_TAG_META = {
    products: {
        label: 'Products',
        description: 'Upload your products so Taka can feature them in promotional posts and ads.',
    },
    people: {
        label: 'People',
        description: 'Photos of you and your team — Taka uses these to put a face to your brand in social posts.',
    },
    other: {
        label: 'Other',
        description: 'Lifestyle shots, locations, or anything else you want Taka to draw inspiration from.',
    },
};
export const MAX_BRAND_IMAGES = 16;
export const DOMAIN_REGEX = /^(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;
export const WEBSITE_URL_REGEX = /^(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/;
export const PLATFORM_DOMAINS = {
    'shopify.com': 'Shopify',
    'myshopify.com': 'Shopify',
    'etsy.com': 'Etsy',
    'squarespace.com': 'Squarespace',
    'wix.com': 'Wix',
    'wixsite.com': 'Wix',
    'wordpress.com': 'WordPress',
    'weebly.com': 'Weebly',
    'bigcommerce.com': 'BigCommerce',
    'mybigcommerce.com': 'BigCommerce',
    'godaddy.com': 'GoDaddy',
    'godaddysites.com': 'GoDaddy',
    'amazon.com': 'Amazon',
};
export function getPlatformName(domain) {
    const cleaned = domain.toLowerCase().replace(/^www\./, '');
    if (PLATFORM_DOMAINS[cleaned])
        return PLATFORM_DOMAINS[cleaned];
    const parts = cleaned.split('.');
    for (let i = 1; i < parts.length; i++) {
        const parent = parts.slice(i).join('.');
        if (PLATFORM_DOMAINS[parent])
            return PLATFORM_DOMAINS[parent];
    }
    return null;
}
//# sourceMappingURL=brand-kit.const.js.map